<div class="vertical-line"></div>
<div class=" reservation_step ">
  <ul>
    <li class="left-link ">

      <span>1.</span> Personal
    </li>
    <li routerLinkActive=" active ">

      <span>2.</span> Conference
    </li>
    <li routerLinkActive="active ">

      <span>3.</span> Accommodation
    </li>
    <li routerLinkActive="active" class="active">

      <span>4.</span> Room Choice
    </li>
    <li routerLinkActive="active ">

      <span>5.</span> Tour
    </li>
    <li routerLinkActive="active " class="right-link ">

      <span>6.</span> Confirm
    </li>
  </ul>
</div>


<!-- <div class="info">
  <form [formGroup]="roomchoiceinfoForm" class="personalinfo">
    <div class="form-group">


      <div class="row">
        <label>Name Of Church</label>
        <input type="text" class="input-field">
      </div>

    </div>
  </form>
</div> -->

<div class="rooms rooms-category">
  <div class="container">
    <div class="row">
      <h3>Please click on any of the buttons below to choose your package:</h3>
      <h5>You must then select three options of hotels in order of preference</h5>
    </div>
    <div class="row">

      <!-- === rooms item === -->

      <div *ngFor="let room of rooms" class="col-sm-6 col-md-6">
        <div class="item">
          <article>
            <!-- <div *ngIf="room.imageUrls[0]" class="image">
              <img src="{{room.imageUrls[0]}}" alt="{{room.name}}" />
            </div> -->
            <p>All Room Packages Include:</p>
            <ul>
              <li>
                Airport pickup & drop-off
              </li>
              <li>
                Accommodation
              </li>
              <li>
                Breakfast
              </li>
              <li>
                Dinner
              </li>
              <li>
                Transport to and from the conference location
              </li>
            </ul>
            <div class="details">
              <div class="text">
                <h2 class="title">
                  <button type=" button" class="btn btn-info" (click)="openModal(room.name)">{{room.name}} - ${{room.price}}/night</button>
                </h2>
              </div>
            </div>
          </article>
        </div>
      </div>

      <!-- <div>
        <button class="btn btn-success" (click)="cancel()">Cancel</button>
        <button class="btn btn-success" (click)="submitRoomChoice()">Next</button>
      </div> -->
    </div>


    <!--/container-->
  </div>


  <kendo-dialog title="Select Hotels In Order Of Preference." *ngIf="opened" (close)="closeModal()" [minWidth]="250" [width]="450">

    <form [formGroup]="roomchoiceinfoForm" (submit)="submitRoomChoice()">

      <div class="form-group">

        <div class="row">
          <label class="col-sm-4">First Choice</label>
          <select formControlName="hotelChoice1" class="k-textbox col-sm-8">
            <option *ngFor="let room of hotelList" value="{{room}}">{{room}}</option>
          </select>
        </div>

        <div class="row">
          <label class="col-sm-4">Second Choice</label>
          <select formControlName="hotelChoice2" class="k-textbox col-sm-8">
            <option *ngFor="let room of hotelList" value="{{room}}">{{room}}</option>
          </select>
        </div>

        <div class="row">
          <label class="col-sm-4">Third Choice</label>
          <select formControlName="hotelChoice3" class="k-textbox col-sm-8">
            <option *ngFor="let room of hotelList" value="{{room}}">{{room}}</option>
          </select>
        </div>

      </div>

      <kendo-dialog-actions>
        <button kendoButton (click)="closeModal()">Cancel</button>
        <button kendoButton type="submit" [disabled]="!roomchoiceinfoForm.valid" primary="true">Save</button>
      </kendo-dialog-actions>
    </form>
  </kendo-dialog>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/roomchoice/roomchoice.component.html